// AdsPage.jsx
import { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import AdsCart from "./modules/AdsCart.jsx";
import { motion } from "framer-motion";
import AdsService from "../../../services/Ads.js";
import { timeAgo, formatNumberForDisplay } from "../../../utiels/functions/persianFormat.js";
import AdsHeader from "./header/Header.jsx";
import EmptyStateMyLoads from "../../../Modals/empty list/EmptyList.jsx";
import AdsSkeleton from "./modules/AdsSkeleton";
import { PiTruckLight } from "react-icons/pi";
import React from "react";


 function AdsPage() {
  const [adsItems, setAdsItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [filterFlag,setFilterFlag]=useState(false)

  const [search, setSearch] = useState("");
  

  // search
  const [filters,setFilters]=useState({})





  async function getAllAds(params = {}) {
    try {
      setLoading(true);
      const defaultParams = {
        limit: 40,
        page: 1,
        pagination: true,
        search:search,
        city:filters["city"]?.city ? filters["city"].city: null,
        type:filters["type"],
        year:filters["year"],
        car:filters["car"],
      };
      console.log(defaultParams)
      const res = await AdsService.getAllAds(defaultParams);
      const items = Array.isArray(res?.data?.data?.docs) ? res.data.data.docs : [];
      setAdsItem(items);
      console.log("Fetched ads:", items);
    } catch (err) {
      console.log("Error fetching ads:", err);
      setAdsItem([]);
      setError("خطا در بارگذاری آگهی‌ها");
    } finally {
      setLoading(false);
    }

  }


  useEffect(() => {
    getAllAds();
  }, [search,filterFlag]);

  const [filterItems, setFilterItems] = useState([
    { main: "نوع معامله", sub: [{ name: "فروش", _id: "sales" }, { name: "اجاره", _id: "rent" }], enable: false, hasSearch: false },
    { main: "شهر", sub: [], enable: false, hasSearch: true },
    { main: "سال تولید", sub: [{ name: "1380", _id: "1380" }, { name: "1390", _id: "1390" }], enable: false, hasSearch: true },
    { main: "مدل ", sub: [{ name: "نیسان وانت", _id: "nissan" }, { name: "تریلی", _id: "trolley" }, { name: "خاور", _id: "khavar" }], enable: false, hasSearch: true }
]);





  function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    const aKeys = Object.keys(objA || {});
    const bKeys = Object.keys(objB || {});
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys) {
      if (objA[key] !== objB[key]) return false;
    }
    return true;
  }


  

useEffect(() => {
    const getSel = (idx) => (filterItems[idx] ? filterItems[idx].selectedVal ?? null : null);
    const newFilters = {
      ...filters,
      type: getSel(0),
      city: getSel(1),
      year: getSel(2),
      car: getSel(3),
    };
  
    setFilters(prev => {
      if (shallowEqual(prev, newFilters)) return prev;
      return newFilters;
    });

  }, [filterItems]);

  if (loading) return (
    <main className="relative w-full min-h-screen py-36 px-4 sm:px-6 max-w-[1200px] mx-auto">
      <AdsSkeleton count={8} />
    </main>
  );
  if (error) return <div className="p-5 text-red-600">{error}</div>;
  console.log("Fetched ads:", adsItems);
  return (
    <>


      <AdsHeader search={search} setSearch={setSearch}  setFilterFlag={setFilterFlag} filterItems={filterItems} setFilterItems={setFilterItems}  />
      <main className="relative w-full min-h-screen py-36 px-4 sm:px-6 max-w-[1200px] mx-auto">

        {
          adsItems?.length == 0 ?
            <>
            <div className="flex flex-col min-h-screen items-center justify-center">
              <EmptyStateMyLoads
                  icon={PiTruckLight}
                  colorContent="text-special"
                  bgColor="transparent"
                  title="آگهی برای نمایش وجود ندارد"
                  subtitle="تاکنون آگهی ثبت نشده است."
                  // onCta={() => { navigate("/registerAds") }}
                  ctaText="افزودن آگهی جدید"
                  ShowButton={false}
                  >


                </EmptyStateMyLoads>
            </div>
         
            </>
            :

            <div className="flex flex-wrap gap-y-6 gap-x-4">
              {adsItems?.map((item, index) => (
                <motion.div
                  key={item._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.06 }}
                  className={`
                border border-gray-300 rounded-xl shadow-sm bg-white overflow-hidden
                h-[390px] md:h-[440px] lg:h-[400px] sm:h-[470px]
                lg:w-[calc(25%-1rem)] md:w-[calc(33.333%-1rem)] sm:w-[calc(50%-1rem)]
                w-full max-sm:w-full max-sm:h-auto
                transform transition-all duration-500 ease-in-out
                hover:scale-105
              `}
                >
                  <AdsCart
                    id={item._id}
                    image={item.image?.path || item.image?.path || ""}
                    title={item?.title || 'عنوان'}
                    description={item?.description || "بدون توضیحات"}
                    price={item?.price ? formatNumberForDisplay(item?.price) : "تماس بگیرید"}
                    dealType={item?.type}
                    postedHoursAgo={timeAgo(item?.createdAt) || "هم اکنون"}
                    index={index}
                    isSaved={item?.isSaved}
                  />
                </motion.div>
              ))}
            </div>
        }
      </main>
      <Footer />


    </>
  );
}

export default React.memo(AdsPage)
